module.exports = __webpack_public_path__ + "img/4.0567b0e8.jpg";